<div class="modal-content">
    <div class="header-container">
        <div class="header-title">
            <span>Deseja mesmo remover o nome personalizado?</span>
        </div>
    </div>

    <div class="description-container">
        Ao remover o nome personalizado não será mais possível visualizar este nome na listagem de contas.
    </div>

    <div class="actions">
        <div class="button-basic-primary cancel-button" (click)="onClick('cancel')">
            Cancelar
        </div>
        <div class="button-basic-primary save-button" (click)="onClick('confirm')">
            Remover
        </div>
    </div>
</div>